import React, {useEffect, useState} from "react";
import {
    LinearProgress,
    Paper, Tab,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Tabs,
    Typography
} from "@material-ui/core";
import {motion} from "framer-motion";
import axios from "axios";
import {PATENT_DETAILS_URL, SEARCH_URL} from "../api/constants";


const PatentDetails = ({applicationNumber}) => {
    const [tabValue, setTabValue] = useState(0);
    const [progress, setProgress] = useState(false);
    const [patent, setPatent] = useState({});

    function handleTabChange(event, value) {
      
        setTabValue(value);
    }

    const getPatentDetails = () => {
        setProgress(true)
        const params = {application_number: applicationNumber}
        axios.get(PATENT_DETAILS_URL, {
            params
        }).then(res => {
            setPatent(res.data)
            setProgress(false)
        }).catch(err => {
            console.log(err)
            setProgress(false)
        })
    }

    useEffect(() => {
        getPatentDetails()
    }, [applicationNumber])

    if(progress){
        return (
            <div>
                <LinearProgress/>
                <Typography color={"textSecondary"} className='p-4 text-center'>Fetching patent details, Please wait...</Typography>
            </div>
        )
    }

    if(!patent.application_number){
        return <Typography className='p-4'>Details not found</Typography>
    }

    return (
        <motion.div
            initial={{y: 30, opacity: 0}}
            animate={{y: 0, opacity: 1, transition: {delay: 0.2}}}
            className=""
        >
            <Tabs
                value={tabValue}
                onChange={handleTabChange}
                indicatorColor='primary'
                textColor='primary'
                variant='scrollable'
                scrollButtons='auto'
                classes={{root: 'h-8'}}
            >
                <Tab className='h-8' label='Patent Details'/>
                <Tab className='h-8' label='Inventors'/>
                <Tab className='h-8' label='Applicants'/>
                <Tab className='h-8' label='Abstract'/>
                <Tab className='h-8' label='Complete Specification'/>
            </Tabs>
            <TableContainer className='w-1/2 flex flex-col py-4'>

                <div className={tabValue !== 0 ? 'hidden' : ''}>
                    <Table aria-label='simple table' size={"small"} className='border border-b-0'>
                        <TableBody>
                            <TableRow>
                                <TableCell align='left' style={{minWidth: 150}}>Invention Title</TableCell>
                                <TableCell align='left'>{patent.invention_title}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell align='left' style={{minWidth: 150}}>Publication Number</TableCell>
                                <TableCell align='left'>{patent.publication_number}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell align='left' style={{minWidth: 150}}>Publication Date</TableCell>
                                <TableCell align='left'>{patent.publication_date}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell align='left' style={{minWidth: 150}}>Publication Type</TableCell>
                                <TableCell align='left'>{patent.publication_type}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell align='left' style={{minWidth: 150}}>Application Number</TableCell>
                                <TableCell align='left'>{patent.application_number}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell align='left' style={{minWidth: 150}}>Application Filing Date</TableCell>
                                <TableCell align='left'>{patent.application_filing_date}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell align='left' style={{minWidth: 150}}>Priority Number</TableCell>
                                <TableCell align='left'>{patent.priority_number}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell align='left' style={{minWidth: 150}}>Priority Country</TableCell>
                                <TableCell align='left'>{patent.priority_country}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell align='left' style={{minWidth: 150}}>Priority Date</TableCell>
                                <TableCell align='left'>{patent.priority_date}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell align='left' style={{minWidth: 150}}>Field Of Innovation</TableCell>
                                <TableCell align='left'>{patent.field_of_invention}</TableCell>
                            </TableRow>
                            <TableRow>
                                <TableCell align='left' style={{minWidth: 150}}>Classification</TableCell>
                                <TableCell align='left'>{patent.classification}</TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </div>
                <div className={tabValue !== 1 ? 'hidden' : ''}>
                    <Table aria-label='simple table' size={"small"} className='border border-b-0'>
                        <TableHead>
                            <TableRow>
                                <TableCell>Name</TableCell>
                                <TableCell>Address</TableCell>
                                <TableCell>Country</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {patent.inventors.map(inventor => (
                                <TableRow>
                                    <TableCell align='left' style={{minWidth: 150}}>{inventor.name}</TableCell>
                                    <TableCell align='left'>{inventor.address}</TableCell>
                                    <TableCell align='left'>{inventor.country}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </div>
                <div
                    className={tabValue !== 2 ? 'hidden' : ''}>
                    <Table aria-label='simple table' size={"small"} className='border border-b-0'>
                        <TableHead>
                            <TableRow>
                                <TableCell>Name</TableCell>
                                <TableCell>Address</TableCell>
                                <TableCell>Country</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {patent.applicant.map(item => (
                                <TableRow>
                                    <TableCell align='left' style={{minWidth: 150}}>{item.name}</TableCell>
                                    <TableCell align='left'>{item.address}</TableCell>
                                    <TableCell align='left'>{item.country}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </div>
                <div className={tabValue !== 3 ? 'hidden' : ''}>
                    <Table aria-label='simple table' size={"small"} className=''>
                        <TableBody>
                            <TableRow>
                                <TableCell align='left'>
                                    {patent.abstract.split('\n').map(str => <p>{str}</p>)}
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </div>
                <div className={tabValue !== 4 ? 'hidden' : ''}>
                    <Table aria-label='simple table' size={"small"}>
                        <TableBody>
                            <TableRow>
                                <TableCell align='left'>
                                    <Typography>
                                        {patent.complete_specification.split('\n').map(str => <p>{str}</p>)}
                                    </Typography>
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </div>

            </TableContainer>


        </motion.div>
    )
}

export default PatentDetails